export const atualizarClienteKeys = {
  cliente: ['clientes-atualizar'] as const,
  atualizar: () => [...atualizarClienteKeys.cliente, 'atualizar'] as const,
}

export const cadastrarClienteKeys = {
  cliente: ['clientes-cadastrar'] as const,
  cadastrar: () => [...cadastrarClienteKeys.cliente, 'cadastrar'] as const,
}
